export enum Situation {
  ACTIVE,
  BLOCKED
}
